export const isInWhitelist = (test: string, whitelist: string[]) => {
  return whitelist.map(w => test.includes(w)).filter(b => b === true).length > 0
}
